import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import HighlightIconPath from '../assets/highlights.svg?react';

export const Container = styled.div`
    display: inline-flex;
    align-items: center;
    height: 32px;
    border-radius: 4px;
    background-color: var(--color-white);
    box-shadow: var(--shadow-1);
    overflow: hidden;
`;

export const ErrorsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 4px;
    height: 100%;
    background-color: ${(props) => (props.warning ? 'var(--color-warning-default)' : 'var(--gray800)')};
    color: ${(props) => (props.warning ? 'var(--gray800)' : 'var(--color-white)')};
`;

export const SelectedErrors = styled.span`
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 28px;
`;

export const TotalErrors = styled.span`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.32px;
    line-height: 16px;
`;

const CustomHighlightIconPath = styled(HighlightIconPath)`
    ${({ theme }) => css`
        fill: ${theme.colors['text-grey-800']};
        height: 16px;
        width: 16px;
        margin-right: 4px;
    `}
`;

const DescriptionContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 8px;
`;

export const Description = styled.span`
    font-size: 12px;
    letter-spacing: 0.32px;
    line-height: 16px;
    text-transform: uppercase;
`;

const ErrorsCounter = ({ selectedErrors = 0, totalErrors = 0 }) => {
    return (
        <Container>
            <ErrorsContainer warning={selectedErrors > totalErrors}>
                <SelectedErrors>{selectedErrors}</SelectedErrors>
                <TotalErrors>{`/${totalErrors}`}</TotalErrors>
            </ErrorsContainer>
            <DescriptionContainer>
                <CustomHighlightIconPath />
                <Description>{'Errori evidenziati'}</Description>
            </DescriptionContainer>
        </Container>
    );
};

ErrorsCounter.propTypes = {
    selectedErrors: PropTypes.number,
    totalErrors: PropTypes.number,
};

export default ErrorsCounter;
